import * as React from "react";

import HeroBanner from "../../components/HeroBan";

import Maintenance from "../../images/HeroBanners/Maintenance.png";

//Heatpumps
import HaierService from "../../images/heatpumps/HaierService.jpg";

import SlideShow from "../../components/slider";
import { useStaticQuery, graphql } from "gatsby";
import Layout from "../../components/layout";

const HeatpumpsService = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "residential/service-and-maintenance", idType: URI) {
          residentialServiceMaintenance {
            contentHeader1
            contentHeader2
            contentLink {
              target
              title
              url
            }
            contentParagraph1
            contentParagraph2
            featuresItems {
              content
              heading
              image {
                altText
                sourceUrl
              }
            }
            heroBackgroundColor
            heroContent
            heroHeading
            heroLink {
              target
              title
              url
            }
            heroImage {
              altText
              sourceUrl
            }
            summarContent
            summaryImage {
              altText
              sourceUrl
            }
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.residentialServiceMaintenance || {};
  return (
    <Layout pageContext={pageContext}>
      <HeroBanner image={Maintenance} color="#FF6A6A">
        <h5>{data?.heroHeading}</h5>
        <p>{data?.heroContent}</p>
        <a href={data?.heroLink?.url}>{data?.heroLink?.title}</a>
      </HeroBanner>
      <div className="w-full bg-black ">
        <div className=" py-20 text-center text-white mx-auto w-11/12 max-w-6xl">
          <div className="flex mx-auto h-28 w-auto mb-7">
            <img
              src={data?.summaryImage?.sourceUrl}
              alt={data?.summaryImage?.altText}
              className="w-full"
            />
          </div>

          <p
            className="text-2xl leading-8"
            dangerouslySetInnerHTML={{ __html: data?.summarContent }}
          ></p>
        </div>
      </div>

      <div className="pt-40 pb-32 flex flex-wrap">
        <ul className="grid grid-cols-1 lg:grid-cols-2 gap-x-20 max-w-7xl mx-10 sm:mx-auto lg:mb-28">
          {data?.featuresItems.map((v, i) => (
            <li key={i} className="grid grid-cols-1 sm:grid-cols-6 ">
              <div className="col-span-1 mt-0.5">
                <div className="flex sm:w-full sm:mb-0 mb-5 max-w-76">
                  <img src={v?.image?.sourceUrl} className="w-full max-h-80" />
                </div>
              </div>
              <div className="col-span-5 flex flex-col">
                <h3 className="text-4xl text-black mb-2">{v?.heading}</h3>
                <p className=" text-xl leading-relaxed mb-auto">{v?.content}</p>
                <div className="bg-tan w-2/3 sm:w-1/3 h-0.5 my-12 lg:mt-28" />
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div style={{ backgroundColor: "#F8F8F8" }}>
        <div className="max-w-5xl text-center lg:mx-auto mx-5 py-20">
          <h3 className="text-4xl text-black mb-10">{data?.contentHeader1}</h3>
          <p
            className="text-xl leading-relaxed"
            dangerouslySetInnerHTML={{ __html: data?.contentParagraph1 }}
          ></p>
          <h3 className="text-4xl text-black mt-14 mb-10">
            {data?.contentHeader2}
          </h3>
          <p
            className="text-xl leading-relaxed"
            dangerouslySetInnerHTML={{ __html: data?.contentParagraph2 }}
          ></p>
          <div className="mt-20">
            <a
              className="bg-tan text-xl text-black uppercase font-anton px-20 py-3 "
              href={data?.contentLink?.url}
              target={data?.contentLink?.target}
              altText={data?.contentLink?.altText}
            >
              {data?.contentLink?.title}
            </a>
          </div>
        </div>
      </div>

      <SlideShow>
        <img src={HaierService} alt="" />
      </SlideShow>
    </Layout>
  );
};

export default HeatpumpsService;
